import React from 'react';
import { 
  ArrowRight,
  Clock,
  DollarSign,
  ShieldCheck,
  Award
} from 'lucide-react';
import { mainServices, engineerInfo } from '../../mock';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';

const ServicesSection = () => {
  const differentials = [
    { icon: Clock, title: 'Entrega no Prazo', description: 'Compromisso com prazos estabelecidos' },
    { icon: DollarSign, title: 'Preço Justo', description: 'Orçamentos transparentes' },
    { icon: ShieldCheck, title: 'CREA RN Ativo', description: 'Profissional regularizada' },
    { icon: Award, title: 'Experiência Comprovada', description: 'Projetos com excelência técnica' }
  ];

  return (
    <section id="servicos" className="py-12 sm:py-16 bg-gradient-to-br from-[#073A40] to-[#06323B]">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mx-auto text-center mb-10">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4">
            Nossos Serviços
          </h2>
          <p className="text-xl sm:text-2xl text-[#F2F2F2] font-medium">
            Do Projeto à Regularização Completa do Seu Imóvel
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {mainServices.map((service) => (
            <Card 
              key={service.id}
              className="group hover:shadow-xl transition-all duration-300 border-2 border-[#A69076] bg-white overflow-hidden hover:scale-105"
            >
              <div className="relative h-48 overflow-hidden">
                {service.type === 'video' ? (
                  <video 
                    className="w-full h-full object-cover"
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    <source src={service.video} type="video/mp4" />
                  </video>
                ) : (
                  <img 
                    src={service.image}
                    alt={service.category}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-[#073A40]/60 to-transparent"></div>
              </div>
              
              <CardHeader>
                <CardTitle className="text-2xl sm:text-3xl text-[#073A40] mb-3 font-bold">
                  {service.category}
                </CardTitle>
                <CardDescription className="text-[#06323B] text-base sm:text-lg leading-relaxed">
                  {service.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {service.services.map((item, index) => (
                    <li key={index} className="flex items-start space-x-2 text-base text-[#06323B]">
                      <span className="text-[#A69076] mt-1 font-bold">•</span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 sm:p-10 mb-10 border-2 border-[#A69076]/50 shadow-lg">
          <h3 className="text-3xl sm:text-4xl font-bold text-white text-center mb-8">
            Por Que Escolher Maria Clara Franceschini?
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {differentials.map((diff, index) => {
              const IconComponent = diff.icon;
              return (
                <div key={index} className="text-center">
                  <div className="w-20 h-20 bg-[#A69076] rounded-full flex items-center justify-center mx-auto mb-4 hover:scale-110 transition-transform">
                    <IconComponent className="text-white" size={32} />
                  </div>
                  <h4 className="text-xl sm:text-2xl font-bold text-white mb-2">
                    {diff.title}
                  </h4>
                  <p className="text-base sm:text-lg text-[#F2F2F2]">
                    {diff.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="text-center">
          <Button 
            asChild
            size="lg"
            className="bg-[#A69076] hover:bg-[#A69F97] text-white font-bold text-lg sm:text-xl px-10 py-7 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <a href={engineerInfo.whatsappLink} target="_blank" rel="noopener noreferrer">
              Solicitar Orçamento Personalizado
              <ArrowRight className="ml-2" size={24} />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
